import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { faSpinner, faTimes, faLock } from '@fortawesome/free-solid-svg-icons';
// import * as $ from 'jquery';
import { MainComponent } from '../main/main.component';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { AppService } from '../shared/services/app.service';
import { UserManagementService } from '../shared/services/user-management.service';
import { Config } from '../config';
declare var $: any;

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-projectselect',
  templateUrl: './projectselect.component.html',
  styleUrls: ['./projectselect.component.scss'],
})
export class ProjectselectComponent implements OnInit {
  // Icons
  faSpinner = faSpinner;
  faTimes = faTimes;
  faLock = faLock;

  languages = [
    { short: 'en', fullform: 'English' },
    { short: 'jp', fullform: 'Japanese' },
  ];
  newProject: any = { projectDetails: { name: '', description: '' } };
  currProject: any = { projectDetails: { name: '', description: '' } };
  // newProject:any = { projectDetails: { name: '', description: '' } };
  // currProject:any = { projectDetails: { name: '', description: '' } };
  newApplicationNameDetails: any = '';
  newApplicationDescDetails: any = '';
  newProjectNameDetails: any = '';
  newProjectDescDetails: any = '';
  currProjectNameDetails: any = '';
  currProjectDescDetails: any = '';
  projects: any = [{ projectDetails: { name: '', description: '' } }];
  IMcheckboxReadOnly: any;
  templates: any;
  templateNames: any;
  slideTimeOut: any;
  currSession: any;
  widgetContent: any;
  widgetContentDesigner: any;
  currentActiveUsers: any = [];
  currentActiveUsersCount: any = 0;
  //currDuration;
  selectedProject: any;
  userName: any;
  // activeusername = $cookies.getObject("activeusername");
  // loginDetails = JSON.parse(localStorage.getItem('loginDetails'));
  changepwd = { oldpassword: '', newpassword: '', confirmpassword: '' };
  language: any;
  dropdownTitle = true;
  // language = localStorage.getItem('language');
  project: any;
  timer: any;
  projectMenuError: any;
  menu: any;
  disableLinks: any;
  // $timeout = $timeout;
  notification: any;
  deleteConfirmationMode: any;
  jottingApp: any;
  projectOpen: any;
  showChooseFile: any = false;
  projectUserListIds = [];
  optradio: any;
  selectedWidgetID = '';
  baseProject: boolean = false;
  selectedBaseProject = {
    "projectDetails": {
      "name": ""
    },
    "cockpit": {},
    "invites": []
  };
  selectedWidgetType = '';
  selectedWidgetDetails = {};
  importCheck: boolean = false;
  listOfparams: any = [];
  listOfparamsForImportList: any = [];
  taskPlannerList: any;
  myTaskPlannerList: any;
  importComplete: any;
  exportReportArray: any;
  activityPageName = '';
  noDataPopupMsg = '';
  videoURL: any;
  getVideoURL: any;
  currentToolname = '';
  sessionId = '';
  groups: any;
  currGroup: any;
  currGroupCreateProject: any;
  selectedGroup: any;
  inviteMailId = '';
  userList: any;
  projectUserList = [];
  orgUserListByProject = [];
  selectAddUser: any;
  selectedUsrToAdd = [];
  selectRemoveUser: any;
  selectedUsrToRemove: any;
  userAddToProject: any;
  userRemoveFromProject: any;
  isUsrAddDisabled = true;
  isUsrRemoveDisabled = true;
  isPrjMrmtDisabled = false;
  loginDetails: any;
  userrole: any;
  selectToRemoveUsr: any;
  selectAdmin: any;
  selectedPlannameInDesigner: any;
  selectUsrToRemoveFromOrg: any;
  orgUserList: any;
  goToBlog: any;
  goToView: any;
  readStatus = false;
  addProjectBtnDisabled = false;
  addApplicationBtnDisabled = false;
  disableReadModeBtn: any;
  currentStateReadModeBtn: any;
  currentReadStatus: any;
  openNav: any;
  closeNav: any;
  closeHamburgerMenu: any;
  sessionHistoryArray = [];
  toggleTreeBranchIcons: any;
  TFToggleStatus = false;
  URToggleStatus = false;
  BFToggleStatus = false;
  interactionTFToggleStatus = false;
  interactionURToggleStatus = false;
  interactionBFToggleStatus = false;
  scopeTFToggleStatus = false;
  scopeURToggleStatus = false;
  scopeBFToggleStatus = false;
  currentSlideId: any;
  inviteMessage = '';
  userDeleteMessage = '';
  updatePlanname = false;
  HighlightRow: any = 0;
  ClickedRow: any;
  socket = '';
  activeProject = {};
  messageContent = '';
  chatUsersList = [];
  chatMessages = [];
  networkConnection = true;
  chatUpdateColor = false;
  chatPopupOpened = false;
  myUserID = window.localStorage.getItem('userID');
  // mySocketID = uniqueEID();
  oldProjectID = window.localStorage.getItem('projectID');
  toastMsgUserStatus = '';
  unreadNotificationCount = 0;
  skipPublicWidgetCount = 0;
  skipPrivateWidgetCount = 0;
  maxWidgetCount = 0;
  skipNotifyCount = 0;
  maxNotifyCount = 0;
  projectsLoaded = false;
  delProUsers = [];
  activeUsersDetails = [];
  applicationsList: any = [];
  activeUsersNames = '';
  allPublicPublishedWidgets = [];
  allPrivatePublishedWidgets = [];

  content: any = [
    {
      listOfAttributes: [],
      myNotes: [],
      suites: [],
      envMap: [],
      listOfEnv: [],
      scenarios: [],
      interactionMap: [],
      personaMap: [],
      scopeMap: [],
      EUTdetails: [],
      listOfEUTs: [],
      listOfBaseEUTs: [],
      modules: [],
      checklists: [],
      persona: [],
    },
  ];
  importedProject: any;
  selectedApplication: any = { "name": '' };
  currProjectName: any;
  $fileContent: any;
  toastMsg: any;
  token: any;
  activeTab = 'openExisting';
  focusmodeData: any = false;
  uploadFileName: any;
  selectedProjectlocation: any = 'Server';
  validJSONfile: boolean = false;
  constructor(
    public translate: TranslateService,
    private ProjectServices: ProjectServicesService,
    public main: MainComponent,
    private http: HttpClient,
    private cookieService: CookieService,
    private cdr: ChangeDetectorRef,
    private appService: AppService,
    private userManagementService: UserManagementService,
    private config: Config
  ) {
    // translate.setDefaultLang('en');
    const browserLang = this.cookieService.get('language');
    this.language = browserLang;
    translate.use(browserLang.match(/en|jp/) ? browserLang : 'en');
    this.ClickedRow = function (index: any) {
      this.HighlightRow = index;
    };
  }

  ngOnInit(): void {
    window.localStorage.setItem("source", this.selectedProjectlocation);
    // activeusername = $cookies.getObject("activeusername");
    this.main.activateLoader(true);
    this.loginDetails = JSON.parse(
      localStorage.getItem('loginDetails') || '{}'
    );
    // console.log('this.loginDetails', this.loginDetails);
    this.userName = this.loginDetails.user_display_name;
    this.token = this.loginDetails.token;
    // console.log("this.token", this.token);
    if (this.token == 'undefined' || this.token == null) {
      window.history.forward();
    }
    this.getApplicationList(this.token);
    this.baseProject = false;
    this.selectedBaseProject = {
      "projectDetails": {
        "name": ""
      },
      "cockpit": {},
      "invites": []
    };
    // this.getProjectList(this.token);
    this.shiftTabs('openExisting');
    setInterval(() => {
      this.focusmodeData = window.localStorage.getItem("focusMode") || false;
      // console.log("this.focusmodeData", this.focusmodeData);
    }, 1000);

    //First time user landing in Application create tab
    setTimeout(() => {
      if (this.loginDetails.newlogin === 0) {
        $('#projectselectOpenExisting').removeClass('active');
        $('#ApplicationreateNew').addClass('active');
        this.shiftTabs('application');
      }
    }, 500);
    this.main.activateLoader(false);
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
    // $('#myProjectsList').on('click', '.clickable-row', function (event:any) {
    //   $(this).addClass('active').siblings().removeClass('active');
    // });
    // $('#myProjectsMgmtTable').on('click', '.clickable-row', function (event:any) {
    //   $(this).addClass('active').siblings().removeClass('active');
    // });
    // $('#validatorScenTable').on('click', '.clickable-row', function (event:any) {
    //   $(this).addClass('active').siblings().removeClass('active');
    // });
    // $('#designerScenTable').on('click', '.clickable-row', function (event:any) {
    //   $(this).addClass('active').siblings().removeClass('active');
    // });
    $('#chooseFile').bind('change', function () {
      var filename = $('#chooseFile').val();
      console.log("filename", filename);
      if (/^\s*$/.test(filename)) {
        $('.file-upload').removeClass('active');
        $('#noFile').text('No file chosen');
      } else {
        $('.file-upload').addClass('active');
        $('#noFile').text(filename.replace('C:\\fakepath\\', ''));
      }
    });
  }

  getApplicationList(token: any) {
    this.ProjectServices.getapplicationList(token).subscribe((response: any) => {
      if (response.statusCode == 200) {
        // console.log('Application', response);
        this.applicationsList = response.records;
        if (this.applicationsList.length > 0) {
          this.selectedApplication = this.applicationsList[0];
          this.getProjectList(this.selectedApplication);
        }
      }
    })
  }

  chooseApplication(app: any) {
    if (app == 'Local') {
      this.selectedProjectlocation = app;
      window.localStorage.setItem("source", app);
      $('#chooseFile').click();
      // this.selectedApplication = {"name": "----Choose from local----"};
      // this.projects = [];
      return;
    }
    this.selectedApplication = app;
    // console.log(this.selectedApplication);
    this.getProjectList(this.selectedApplication);
    this.baseProject = false;
    this.selectedBaseProject = {
      "projectDetails": {
        "name": ""
      },
      "cockpit": {},
      "invites": []
    };
  }
  getProjectList(application: any) {
    this.ProjectServices.loadProjects(application).subscribe((response: any) => {
      // console.log('login res', response);
      if (response.statusCode == 200) {
        // console.log('response project list success', response.record);
        this.projectsLoaded = true;
        this.projects = response.record;
        if (this.projects.length > 0) {
          this.chooseBaseProject(this.projects[this.projects.length - 1]);
        }
        // sorting as per alphabetical order
        // this.projects.sort((a: any, b: any) =>
        //   a.projectDetails.name.localeCompare(b.projectDetails.name)
        // );
        // console.log('this.projects', this.projects);

        this.currProject = this.projects[0] || { projectDetails: { name: '', description: '' } };
        this.selectedProject = this.projects[0] || {};
        // this.modelDataCopy = JSON.stringify(this.projects[0] || {})
        // if (this.oldProjectID == null || this.oldProjectID == undefined) {
        this.setCurrentProject(this.currProject);
        this.HighlightRow = 0;
        // } else {
        //   var cProject = this.projects.find(
        //     (project: any) => project._id === this.oldProjectID
        //   );
        //   this.setCurrentProject(cProject);
        //   let index = this.projects.findIndex(
        //     (x: any) => x._id === this.oldProjectID
        //   );
        //   this.HighlightRow = index;
        // }
        this.getOrgUsers();
        this.manageSelectedProject(this.currProject);
        if (this.projects.length == 0) {
          this.isPrjMrmtDisabled = true;
        }
      }
    });
  }

  getOrgUsers() { }
  manageSelectedProject(currProject: any) {
    // console.log('manageSelectedProject', currProject);
    this.currProject = currProject;
    localStorage.setItem('projectName', currProject.projectDetails.name);
    localStorage.setItem('projectID', currProject._id);
    localStorage.setItem('applicationID', currProject.applicationId);
  }

  clearImportDetails() {
    $('#import>input[type="checkbox"]').prop('checked', false).change();
    $("#noFile").text("No file chosen");
    this.newProject.projectDetails.name = '';
    this.newProject.projectDetails.description = '';
    this.importCheck = false;
    this.importComplete = false;
    this.listOfparams = [];
    // this.angular.element("input[type='file']").val(null);
    this.content = [];
    this.listOfparamsForImportList = [];
  }
  cancelImport() {
    $('#import>input[type="checkbox"]').prop('checked', false).change();
    $("#noFile").text("No file chosen");
    this.importCheck = false;
    this.importComplete = false;
    this.listOfparams = [];
    // angular.element("input[type='file']").val(null);
    this.content = [];
    this.listOfparamsForImportList = [];
  }

  addApplication() {
    // console.log('name', this.newApplicationNameDetails);
    // console.log('desc', this.newApplicationDescDetails);
    if (this.newApplicationNameDetails == '' || this.newApplicationDescDetails == '') {
      this.triggerToastforApplication("Fields can't be empty");
      return;
    }
    var appData = {
      "name": this.newApplicationNameDetails,
      "description": this.newApplicationDescDetails
    }
    this.ProjectServices.addApplication(appData).subscribe((response: any) => {
      // console.log('application res', response);
      if (response.statusCode == 200) {
        this.triggerToastforApplication(response.message);
        this.newApplicationNameDetails = '';
        this.newApplicationDescDetails = '';
        this.getApplicationList(this.token);
      } else {
        this.triggerToastforApplication(response.message);
      }

    });
  }
  chooseBaseProject(project: any) {
    this.selectedBaseProject = project;
    this.baseProject = true;
    // console.log("Base", this.selectedBaseProject);
  }
  addProject(type: any, newProject: any) {

    if (this.selectedApplication._id) {
      var newProject = newProject;
      newProject.projectDetails.templateName = 'default';
      newProject.projectDetails.uisettingName = 'default';
      newProject.projectDetails.createdOn = Date.now();
      newProject.projectDetails.lastModifiedOn = Date.now();
      newProject.projectDetails.name = this.capitalizeFirstLetter(this.newProjectNameDetails);
      newProject.projectDetails.description = this.newProjectDescDetails;
      if (this.newProject.projectDetails.name.toLowerCase() == 'demo app') {
        this.triggerToast(this.appService.getResourceText('R014'));
        return;
      } else {
        newProject.projectDetails.name = this.capitalizeFirstLetter(this.newProject.projectDetails.name);
        newProject.projectDetails.description = this.newProject.projectDetails.description;
        newProject.projectDetails.readOnly = false;
        newProject.projectDetails.projectType = 'public';

        if (newProject.cockpit === undefined) {
          // console.log('newProject2', this.newProjectModel());
          var data;
          if (this.baseProject === true) {
            data = this.selectedBaseProject;
            newProject.invites = data.invites;
          } else {
            data = this.newProjectModel();
          }

          newProject.baseProject = this.baseProject;
          newProject.list = data.list;
          newProject.details = data.details;
          newProject.listOfBaseEUTs = data.listOfEUTs;
          newProject.listOfEUTs = [];
          newProject.personaMap = data.personaMap;
          newProject.scopeMap = data.scopeMap;
          newProject.persona = data.persona;
          newProject.EUTdetails = data.EUTdetails;
          newProject.modules = data.modules;
          newProject.scenarios = data.scenarios;
          newProject.suites = data.suites;
          newProject.interactionMap = data.interactionMap;
          newProject.listOfEnv = data.listOfEnv;
          newProject.runInfo = data.runInfo;
          newProject.envMap = data.envMap;
          newProject.myNotes = data.myNotes;
          newProject.listOfAttributes = data.listOfAttributes;
          newProject.applicationId = this.selectedApplication._id;
          if (this.baseProject === true) {
            newProject.cockpit = this.selectedBaseProject.cockpit;
          } else {


            newProject.cockpit = {
              //tasks+
              functionalScenarioCount: 0,
              functionalScenarioPostiveCount: 0,
              functionalScenarioNegativeCount: 0,
              nonFunctionalScenarioCount: 0,
              nonFunctionalScenarioPostiveCount: 0,
              nonFunctionalScenarioNegativeCount: 0,
              //readyness
              readyEUTStatus: 0,
              scenarioTFStatus: 0,
              scenarioBFStatus: 0,
              scenarioURStatus: 0,
              scenarioXXStatus: 0,
              scenarioTF: 0,
              scenarioBF: 0,
              scenarioUR: 0,
              scenarioXX: 0,
              Attributestatus: 0,
              //evaluvated
              EUTEvaluationStatus: 0,
              EUTEvaluationCount: 0,
              scenarioExecTFStatus: 0,
              scenarioExecTF: 0,
              scenarioExecBFStatus: 0,
              scenarioExecBF: 0,
              scenarioExecURStatus: 0,
              scenarioExecUR: 0,
              scenarioExecXXStatus: 0,
              scenarioExecXX: 0,
              AttributeEvaluationStatus: 0,
              AttributeEvaluationCount: 0,
              //outcomes
              EUTCleanStatus: 0,
              cleanEUTOutcome: 0,
              EUTCleanTFStatus: 0,
              cleanEUTTFOutcome: 0,
              EUTCleanBFStatus: 0,
              cleanEUTBFOutcome: 0,
              EUTCleanURStatus: 0,
              cleanEUTUROutcome: 0,
              EUTCleanXXStatus: 0,
              cleanEUTXXOutcome: 0,
              AttriCleanStatus: 0,
              cleanAttriOutcome: 0,
            }
          }
        }
        if (newProject.checklists === undefined) {
          newProject.checklists = [];
        }

        // newProject.projectDetails.readOnly = true; // for demo app project creation
      }
      // newProject.orgId = this.currGroupCreateProject.org_refId;
      // newProject.groupId = this.currGroupCreateProject.groupId;

      var isFilled =
        newProject.projectDetails.name && newProject.projectDetails.templateName;
      var isValid = !this.projects.find(
        (project: any) =>
          project.projectDetails.name === newProject.projectDetails.name
      );

      var isModifyValid = false;
      if (type === 'modify') {
        isModifyValid =
          newProject.projectDetails.name === this.selectedProject.name;
      }
      if (isFilled) {
        if (isValid || isModifyValid) {
          this.addProjectBtnDisabled = true;
          /// switch case code removed temply
          // console.log('latestProject', newProject);
          this.ProjectServices.addProject(newProject, this.token).subscribe(
            (response: any) => {
              // console.log('addProject res', response);
              if (response.statusCode == 200) {
                localStorage.setItem('projectID', response.record._id);
                localStorage.setItem('applicationID', response.record.applicationId);
                this.main.startSession(
                  response.record,
                  false,
                  response.record._id
                );
                this.main.activateLoader(false);
                this.projectOpen = true;
                // this.startSession(newProject, true, response._id);
                var projectJSONwithID = newProject;
                projectJSONwithID._id = response.record._id;
                localStorage.setItem('projectID', response.record._id);
                localStorage.setItem('applicationID', response.record.applicationId);
                localStorage.setItem(
                  'projectName',
                  response.record.projectDetails.name
                );
              } else {
                this.addProjectBtnDisabled = false;
                // this.triggerToast(response.message);
              }
            }
          );
        } else {
          this.triggerToast(this.appService.getResourceText('R002'));
        }
      } else {
        this.triggerToast(this.appService.getResourceText('R001'));
      }

    } else {
      this.triggerToast("Please Create application to add project.");
      return;
    }
    // console.log('newProject', newProject);
  }

  presentInImportList(key: any, value: any) {
    var found = this.listOfparams.find((param: any) => param == key);
    if (found) {
      this.isAllSelected();
      return true;

      // if (value) {
      //   return true;
      // } else {
      //   return false;
      // }
    } else {
      return false;
    }
  }

  capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  changeinImport(key: any, checkValue: boolean) {
    checkValue ? this.listOfparams.push(key) : this.deleteFromList(key);
  }

  deleteFromList(key: any) {
    var index = this.listOfparams.findIndex((param: any) => param == key);
    if (index > -1) {
      this.listOfparams.splice(index, 1);
    }
  }

  openImportModal() {
    $('#importSelectionModal').modal('show');

    var isValid = !this.projects.find(
      (project: any) =>
        project.projectDetails.name === this.newProject.projectDetails.name
    );
    // this.entities = this.entities.filter(entity => entity.id !== id);
    // console.log('isvalid', isValid);

    if (this.newProject.projectDetails.name != '') {
      if (isValid) {
        if (this.content) {
          if (this.content.length != 0 || this.content.length == undefined) {
            $('#importSelectionModal').modal('show');
          } else {
            this.triggerToast(this.appService.getResourceText('R013'));
          }
        } else {
          this.triggerToast(this.appService.getResourceText('R010'));
        }
      } else {
        this.triggerToast(this.appService.getResourceText('R002'));
      }
    } else {
      this.triggerToast(this.appService.getResourceText('R001'));
    }
  }

  addJsonAsProject() {
    this.main.activateLoader(true);
    this.importCheck = false;
    this.importedProject = {};
    for (var key in this.content) {
      var exist = this.listOfparams.find((param: any) => param == key);
      if (exist) {
        this.importedProject[key] = this.content[key];
        //this.importedProject[key].uisettingName = "default";
      } else if (
        key == 'uisettingName' ||
        key == 'session' ||
        key == 'noOfSessions'
      ) {
        this.importedProject[key] = '';
      } else if (key == 'projectDetails') {
        this.importedProject[key] = {};
      } else if (
        key == '_id' ||
        key == 'invites' ||
        key == 'createdBy' ||
        key == 'orgId' ||
        key == 'createdOn' ||
        key == 'lastModifiedOn' ||
        key == '__v' ||
        key == 'checklists'
      ) {
      } else {
        this.importedProject[key] = [];
      }
    }
    this.importedProject['cockpit'] = {
      //tasks+
      functionalScenarioCount: 0,
      functionalScenarioPostiveCount: 0,
      functionalScenarioNegativeCount: 0,
      nonFunctionalScenarioCount: 0,
      nonFunctionalScenarioPostiveCount: 0,
      nonFunctionalScenarioNegativeCount: 0,
      //readyness
      readyEUTStatus: 0,
      scenarioTFStatus: 0,
      scenarioBFStatus: 0,
      scenarioURStatus: 0,
      scenarioXXStatus: 0,
      scenarioTF: 0,
      scenarioBF: 0,
      scenarioUR: 0,
      scenarioXX: 0,
      Attributestatus: 0,
      //evaluvated
      EUTEvaluationStatus: 0,
      EUTEvaluationCount: 0,
      scenarioExecTFStatus: 0,
      scenarioExecTF: 0,
      scenarioExecBFStatus: 0,
      scenarioExecBF: 0,
      scenarioExecURStatus: 0,
      scenarioExecUR: 0,
      scenarioExecXXStatus: 0,
      scenarioExecXX: 0,
      AttributeEvaluationStatus: 0,
      AttributeEvaluationCount: 0,
      //outcomes
      EUTCleanStatus: 0,
      cleanEUTOutcome: 0,
      EUTCleanTFStatus: 0,
      cleanEUTTFOutcome: 0,
      EUTCleanBFStatus: 0,
      cleanEUTBFOutcome: 0,
      EUTCleanURStatus: 0,
      cleanEUTUROutcome: 0,
      EUTCleanXXStatus: 0,
      cleanEUTXXOutcome: 0,
      AttriCleanStatus: 0,
      cleanAttriOutcome: 0,
    };
    if (this.importedProject.envMap && this.importedProject.listOfEnv) {
      if (
        this.importedProject.envMap.length <= 0 &&
        this.importedProject.listOfEnv.length > 0
      ) {
        var newTask = {
          description: 'Do Environment map',
          starttime: Date.now(),
          endTime: '0:00',
          status: 0,
          completed: false,
        };
        // this.importedProject.tasks.push(newTask);
      }
    }
    if (
      this.importedProject.personaMap &&
      this.importedProject.persona &&
      this.importedProject.listOfEUTs
    ) {
      if (
        this.importedProject.personaMap.length <= 0 &&
        this.importedProject.persona.length > 0 &&
        this.importedProject.listOfEUTs.length > 0
      ) {
        var newTask = {
          description: 'Do Persona map',
          starttime: Date.now(),
          endTime: '0:00',
          status: 0,
          completed: false,
        };
        // this.importedProject.tasks.push(newTask);
      }
    }
    if (this.importedProject.scopeMap && this.importedProject.listOfEUTs) {
      if (
        this.importedProject.scopeMap.length <= 0 &&
        this.importedProject.listOfEUTs.length > 0
      ) {
        var newTask = {
          description: 'Do Scope map',
          starttime: Date.now(),
          endTime: '0:00',
          status: 0,
          completed: false,
        };
        // this.importedProject.tasks.push(newTask);
      }
    }
    if (
      this.importedProject.interactionMap &&
      this.importedProject.listOfEUTs
    ) {
      if (
        this.importedProject.interactionMap.length <= 0 &&
        this.importedProject.listOfEUTs.length > 1
      ) {
        var newTask = {
          description: 'Do Interaction map',
          starttime: Date.now(),
          endTime: '0:00',
          status: 0,
          completed: false,
        };
        // this.importedProject.tasks.push(newTask);
      }
    }
    if (
      this.importedProject.listOfEUTs &&
      this.importedProject.persona &&
      this.importedProject.listOfEUTs
    ) {
      if (
        this.importedProject.listOfEUTs.length <= 0 &&
        this.importedProject.persona.length <= 0 &&
        this.importedProject.listOfEUTs.length <= 0
      ) {
        var newTask = {
          description: 'Do Landscape',
          starttime: Date.now(),
          endTime: '0:00',
          status: 0,
          completed: false,
        };
        // this.importedProject.tasks.push(newTask);
      }
    }
    this.importedProject['applicationId'] = this.selectedApplication._id;
    // console.log("this.selectedApplication",this.selectedApplication);
    // console.log("his.importedProject",this.importedProject);
    this.addProject('add', this.importedProject);
  }

  setCurrentProject(currProject: any) {
    if (currProject.projectDetails) {
      this.currProjectName = currProject.projectDetails.name;
      this.currProjectDescDetails = currProject.projectDetails.description;
      localStorage.setItem('projectName', currProject.projectDetails.name);
    }
    this.currProject = currProject;
    localStorage.setItem('projectID', currProject._id);
    localStorage.setItem('applicationID', currProject.applicationId);
  }

  checkImportCheckbox(name: any, checkboxStatus: any) {
    if (name == '' || name == null) {
      if (checkboxStatus == true) {
        this.cancelImport();
      }
    }
  }
  showContent(event: any) {
    this.importComplete = false;
    this.listOfparams = [];
    this.content = [];
    this.listOfparamsForImportList = [];
    const fileToLoad = event.target.files[0];
    console.log("fileToLoad", event);
    this.uploadFileName = fileToLoad.name;
    const fileReader = new FileReader();
    let self = this;
    fileReader.onloadend = function (fileLoadedEvent: any) {
      const textFromFileLoaded: any = fileLoadedEvent.target.result;
      self.content = fileLoadedEvent.target.result;
      self.getJsonData(fileLoadedEvent.target.result);
      // const json = JSON.parse(textFromFileLoaded);
      // localStorage.setItem('json', textFromFileLoaded);
    };
    fileReader.readAsText(fileToLoad, 'UTF-8');
    // this.content = localStorage.getItem('json');
    // this.content = JSON.parse(this.content);
    // if (this.content) {
    //   for (var key in this.content) {
    //     if (
    //       key == 'listOfAttributes' ||
    //       key == 'suites' ||
    //       key == 'envMap' ||
    //       key == 'listOfEnv' ||
    //       key == 'scenarios' ||
    //       key == 'runInfo' ||
    //       key == 'interactionMap' ||
    //       key == 'personaMap' ||
    //       key == 'scopeMap' ||
    //       key == 'EUTdetails' ||
    //       key == 'listOfEUTs' ||
    //       key == 'persona' ||
    //       key == 'checklists' ||
    //       key == 'myNotes'
    //     ) {
    //       this.listOfparams.push(key);
    //       this.listOfparamsForImportList.push(key);
    //     }
    //   }
    // }
    // this.newProject.projectDetails.name = this.newProjectNameDetails;
    // this.newProject.projectDetails.description = this.newProjectDescDetails;
  }

  getJsonData(jsonData: any) {
    this.content = JSON.parse(jsonData);
    this.validJSONfile = false;
    console.log("this.content", this.content);
    if (this.content) {
      for (var key in this.content) {
        if (
          key == 'listOfAttributes' ||
          key == 'suites' ||
          key == 'envMap' ||
          key == 'listOfEnv' ||
          key == 'modules' ||
          key == 'scenarios' ||
          key == 'runInfo' ||
          key == 'interactionMap' ||
          key == 'personaMap' ||
          key == 'scopeMap' ||
          key == 'EUTdetails' ||
          key == 'listOfEUTs' ||
          key == 'listOfBaseEUTs' ||
          key == 'persona' ||
          key == 'cockpit' ||
          key == 'checklists' ||
          key == 'myNotes'
        ) {
          this.listOfparams.push(key);
          this.listOfparamsForImportList.push(key);
          this.validJSONfile = true;
        } else {
          this.validJSONfile = false;
        }
      }
    }
    console.log(this.validJSONfile);
    this.newProject.projectDetails.name = this.newProjectNameDetails;
    this.newProject.projectDetails.description = this.newProjectDescDetails;
    // if(this.validJSONfile == true){
    this.openLocalProject();
    // }else{
    //   $('#openProjectFromLocal').modal('show');
    // }

  }

  openLocalProject() {
    console.log("this.content", this.content);
    this.manageSelectProjectOpen(this.content);
  }
  setCurrentProjectFromDL(projectName: any) {
    if (projectName == undefined) {
      this.currProjectName = '';
      this.currProjectDescDetails = '';
      this.currProject = '';
    } else {
      // var isValidSearch = this.projects.find(
      //   // project => project.projectDetails.name === projectName
      // );
      // if (isValidSearch != undefined && isValidSearch != null) {
      //   for (let p = 0; p < this.projects.length; p++) {
      //     if (projectName == this.projects[p].projectDetails.name) {
      //       this.currProjectName = projectName;
      //       this.currProject = this.projects[p];
      //       if (this.projects[p].projectDetails) {
      //         window.localStorage.setItem("projectName", this.currProject.projectDetails.name);
      //       }
      //       window.localStorage.setItem("projectID", this.currProject._id);
      //     }
      //   }
      // } else {
      //   this.currProjectName = '';
      //   this.currProject = '';
      // }
    }
  }
  setImportComplete() {
    this.importComplete = true;
    $('#importSelectionModal').modal('hide');
  }

  manageSelectProjectOpen(currProject: any) {
    if (currProject == '') {
      this.triggerToastforOpenProject(this.appService.getResourceText('R012'));
    } else if (!currProject.projectDetails) {
      $('#openProjectFromLocal').modal('show');
    } else {
      $('.projectOpenSpinner').show();
      this.main.activateLoader(true);
      this.manageSelectedProject(currProject);
      // localStorage.setItem('projectID', currProject._id);
      // localStorage.setItem('applicationID', currProject.applicationId);
      // this.main.startSession(currProject, false, '');
      if (this.importCheck == false) {
        localStorage.setItem('projectID', currProject._id);
        localStorage.setItem('applicationID', currProject.applicationId);
        this.main.startSession(currProject, false, '');
      } else {
        this.content = currProject;
        this.addJsonAsProject();
      }
    }
  }

  selectAllForImport(isChecked: any) {
    this.listOfparams = [];
    if (isChecked) {
      if (this.content) {
        for (var key in this.content) {
          if (
            key == 'listOfAttributes' ||
            key == 'suites' ||
            key == 'envMap' ||
            key == 'listOfEnv' ||
            key == 'modules' ||
            key == 'scenarios' ||
            key == 'interactionMap' ||
            key == 'personaMap' ||
            key == 'scopeMap' ||
            key == 'EUTdetails' ||
            key == 'listOfEUTs' ||
            key == 'listOfBaseEUTs' ||
            key == 'persona' ||
            key == 'checklists' ||
            key == 'myNotes'
          ) {
            this.listOfparams.push(key);
          }
        }
      } else {
        this.listOfparams = [];
      }
    } else {
      this.listOfparams = [];
    }
  }

  isAllSelected() {
    var count = 0;
    if (this.content) {
      for (var key in this.content) {
        if (
          key == 'listOfAttributes' ||
          key == 'myNotes' ||
          key == 'suites' ||
          key == 'envMap' ||
          key == 'listOfEnv' ||
          key == 'modules' ||
          key == 'scenarios' ||
          key == 'interactionMap' ||
          key == 'personaMap' ||
          key == 'runInfo' ||
          key == 'scopeMap' ||
          key == 'EUTdetails' ||
          key == 'listOfEUTs' ||
          key == 'listOfBaseEUTs' ||
          key == 'persona' ||
          key == 'checklists'
        ) {
          count++;
        }
      }
    }
    if (count == this.listOfparams.length) {
      return true;
    } else {
      return false;
    }
  }

  triggerToastforApplication(message: any) {
    this.toastMsg = message;
    $('#snackbar2').html(message);
    var x: any = document.getElementById('snackbar2');
    x.className = 'show';
    setTimeout(function () {
      x.className = x.className.replace('show', '');
    }, 3000);
  }

  triggerToastforOpenProject(message: any) {
    this.toastMsg = message;
    $('#snackbar1').html(message);
    var x: any = document.getElementById('snackbar1');
    x.className = 'show';
    setTimeout(function () {
      x.className = x.className.replace('show', '');
    }, 3000);
  }

  triggerToastforCreateProject(message: any) {
    this.toastMsg = message;
    $('#snackbar3').html(message);
    var x: any = document.getElementById('snackbar3');
    x.className = 'show';
    setTimeout(function () {
      x.className = x.className.replace('show', '');
    }, 3000);
  }

  triggerToast(message: any) {
    this.toastMsg = message;
    $('#snackbar1').html(message);
    var x: any = document.getElementById('snackbar1');
    x.className = 'show';
    setTimeout(function () {
      x.className = x.className.replace('show', '');
    }, 3000);
  }

  triggerToastUser(message: any) {
    this.toastMsgUserStatus = message;
    $('#userStatusToast').html(message);
    var x: any = document.getElementById('userStatusToast');
    x.className = 'show';
    setTimeout(function () {
      x.className = x.className.replace('show', '');
    }, 3000);
  }

  readmode(status: any) {
    // console.log('readmode function called', status);
    if (status == false) {
      // document.getElementById("readonlyOverLay").style.display = "block";
      this.readStatus = true;
      $('.readOnlyForm :input').prop('disabled', true);
      $('.readOnlyFormPlanner :input').prop('disabled', true);
      $('.readOnlyFormPlanner :checkbox').prop('disabled', false);
      $('.readOnlyForm :button').prop('disabled', false);
      // $(".labelReadOnly").attr("disabled", true);
      // $(".checkboxReadOnly").attr("disabled", false);
      this.IMcheckboxReadOnly = true;
      // $(".mappercheckboxReadOnly").attr("disabled", false);
      $('.mapperReadOnly').css('pointer-events', 'none');
      $('.mapperReadOnly').css('cursor', 'not-allowed');
      $('.readOnlyModeBtn').addClass('active');
    } else {
      // document.getElementById("readonlyOverLay").style.display = "none";
      this.readStatus = false;
      $('.readOnlyForm :input').prop('disabled', false);
      $('.readOnlyFormPlanner :input').prop('disabled', false);
      // $(".labelReadOnly").attr("disabled", false);
      // $(".checkboxReadOnly").attr("disabled", false);
      // $(".mappercheckboxReadOnly").attr("disabled", true);
      this.IMcheckboxReadOnly = false;
      $('.mapperReadOnly').css('pointer-events', '');
      $('.mapperReadOnly').css('cursor', 'pointer');
      $('.readOnlyModeBtn').removeClass('active');
    }
  }
  shiftTabs(tabname: any) {
    // console.log(tabname);
    this.activeTab = tabname;
  }

  newProjectModel() {
    var data: any = {
      _id: -1, list: [], details: { levels: [], jottings: [], notes: [], questions: [] },
      sessions: [], listOfEUTs: [], listOfBaseEUTs: [], modules: [], personaMap: [], persona: [], scopeMap: [],
      EUTdetails: [], interactionMap: [], scenarios: [], suites: [], listOfEnv: [], runInfo: [], envMap: [], myNotes: [],
      listOfAttributes: []
    }
    var model: any = {};

    model.list = data.list;
    model.details = data.details;
    model.listOfEUTs = data.listOfEUTs;
    model.listOfBaseEUTs = data.listOfBaseEUTs;
    model.personaMap = data.personaMap;
    model.scopeMap = data.scopeMap;
    model.persona = data.persona;
    model.modules = data.modules;
    model.EUTdetails = data.EUTdetails;
    model.scenarios = data.scenarios;
    model.suites = data.suites;
    model.interactionMap = data.interactionMap;
    model.listOfEnv = data.listOfEnv;
    model.runInfo = data.runInfo;
    model.envMap = data.envMap;
    model.myNotes = data.myNotes;
    model.listOfAttributes = [];
    return model;
  }
}
